import { FC, useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useTemplatePreviewStore } from '../../provider';
import { containerStyle } from './preview-mode-changer.style';

const PreviewModeChanger: FC = () => {
  const { t } = useTranslation('forms');
  const { previewMode, setPreviewMode } = useTemplatePreviewStore(['previewMode', 'setPreviewMode']);

  const desktopPreviewHandler = useCallback(() => {
    setPreviewMode('desktop');
  }, [setPreviewMode]);

  const mobilePreviewHandler = useCallback(() => {
    setPreviewMode('mobile');
  }, [setPreviewMode]);

  return (
    <section css={containerStyle}>
      <div>
        <Button
          iconName='computer'
          variant={previewMode === 'desktop' ? 'tertiary' : 'secondary'}
          hoverLabel={t('Desktop Preview')}
          onClick={desktopPreviewHandler}
        />
        <Button
          iconName='cell-phone'
          variant={previewMode === 'mobile' ? 'tertiary' : 'secondary'}
          hoverLabel={t('Preview on your mobile device')}
          onClick={mobilePreviewHandler}
        />
      </div>
    </section>
  );
};

export default PreviewModeChanger;
